import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SearchComponent} from './components/search/search.component';
import {SearchResolver} from './components/search/search-resolver';
import {ProductComponent} from './components/product/product.component';
import {ProductResolver} from './services/product.resolver';
import {ContainerComponent} from './components/container/container.component';
import {ArticleResolver} from "./services/article.resolver";
import {ArticleComponent} from "./components/article/article.component";
import {AppSearchComponent} from "./components/app-search/app-search.component";
import {AppSearchResolver} from "./services/app-search.resolver";

const routes: Routes = [
    {
        path: '',
        component: ContainerComponent,
        children: [
            {
                path: '',
                component: SearchComponent,
                resolve: {
                    searchResult: SearchResolver
                },
                runGuardsAndResolvers: 'always'
            },
            {
                path: 'product/:id',
                component: ProductComponent,
                runGuardsAndResolvers: 'always',
                resolve: {
                    productResult: ProductResolver,
                },
            },
            {
                path: 'product/:id/:slug',
                component: ProductComponent,
                runGuardsAndResolvers: 'always',
                resolve: {
                    productResult: ProductResolver,
                },
            },
            {
                path: 'article/:id',
                component: ArticleComponent,
                resolve: {
                    articleResult: ArticleResolver,
                },
            },
            {
                path: 'article/:id/:slug',
                component: ArticleComponent,
                resolve: {
                    articleResult: ArticleResolver,
                },
            },
            {
                path: 'search',
                component: AppSearchComponent,
                runGuardsAndResolvers: 'always',
                resolve: {
                    appSearchResult: AppSearchResolver,
                },
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CatalogueRoutingModule {
}
